<template>
  <div class="swiper-card card-profile">
    <div class="corner-radius-blur"></div>
    <div class="content-stack">
      <svg width="37" height="50" viewBox="0 0 37 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.625 18.75V40.5762C7.15911 40.0977 9.88594 40.9375 11.7167 43.0664L12.3333 43.7793L12.6995 43.3594C15.7732 39.8047 21.2268 39.8047 24.3005 43.3594L24.6667 43.7793L25.2833 43.0664C27.1141 40.9375 29.8409 40.0977 32.375 40.5762V18.75C32.375 10.9863 26.1602 4.6875 18.5 4.6875C10.8398 4.6875 4.625 10.9863 4.625 18.75ZM24.6667 50C24.1753 50 23.7128 49.7852 23.3852 49.4141L20.8221 46.4355C19.5984 45.0098 17.4112 45.0098 16.1779 46.4355L13.6148 49.4141C13.2969 49.7852 12.8247 50 12.3333 50C11.8419 50 11.3794 49.7852 11.0518 49.4141L8.23828 46.1426C7.12057 44.8437 5.14531 44.7754 3.95052 45.9961L3.72891 46.2207C3.32422 46.6309 2.76536 46.8652 2.18724 46.8652C0.982812 46.8652 0.009636 45.8789 0.009636 44.6582L0 18.75C0 8.39844 8.28646 0 18.5 0C28.7135 0 37 8.39844 37 18.75V44.668C37 45.8887 36.0268 46.875 34.8224 46.875C34.2443 46.875 33.6854 46.6406 33.2807 46.2305L33.0591 46.0059C31.8547 44.7852 29.8891 44.8535 28.7714 46.1523L25.9482 49.4141C25.6302 49.7852 25.1581 50 24.6667 50ZM9.25 18.75C9.25 17.0215 10.6279 15.625 12.3333 15.625C14.0388 15.625 15.4167 17.0215 15.4167 18.75C15.4167 20.4785 14.0388 21.875 12.3333 21.875C10.6279 21.875 9.25 20.4785 9.25 18.75ZM21.5833 18.75C21.5833 17.0215 22.9612 15.625 24.6667 15.625C26.3721 15.625 27.75 17.0215 27.75 18.75C27.75 20.4785 26.3721 21.875 24.6667 21.875C22.9612 21.875 21.5833 20.4785 21.5833 18.75Z" fill="#FFDE00"/>
      </svg>
      <h3>Choose your handle</h3>
      <p>Make it yours—choose a handle to create your personal invitation page.</p>
    </div>

    <form @submit.prevent="setUsername()" v-if="!isWorking">
      <div class="message" v-if="response.message" :class="response.reason === 'okay' ? 'success' : 'warn'">
        {{ response.message }}
      </div>
      <input type="text" v-model="username">
      <button :disabled="!changed" type="submit">Check handle</button>
    </form>

    <div v-else>
      <Fetching />
    </div>
  </div>
</template>

<script>
  import API from "app/axios.js";
  import Fetching from '@/components/v5/Fetching.vue';

  export default {
    data() {
      return {
        username: '',
        username_original: '',
        isWorking: false,
        response: {},
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    components: {
      Fetching,
    },

    async mounted () {
      await API.getAccount(localStorage.getItem('token'));
      this.username = this.getAccount.screen_name;
      // this.username_original = this.username;

      this.$emit('enableNextAction');
      this.$emit('swiperUpdate');
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },

      changed() {
        return this.username != this.username_original;
      },
    },

    methods: {
      setUsername() {
        this.isWorking = true;
        API.patch(`/account/screen-name`, {
          new: this.username,
          write: 'on'
        }).then((response) => {
          this.response = response.data;
          this.isWorking = false;
          this.$emit('swiperUpdate')

          if (this.response.reason === 'taken') {
            this.username = this.response.suggestions[0]
            this.username_original = this.username;
          } else {
            // console.log(response.data);
            this.$emit('enableNextAction');
            this.username = this.response?.screen_name
            this.username_original = this.username;
            this.$userEngine.reload();
            // this.$emit('next'); // removed ... it's really jarring ... and you miss the message!
          }
        }).catch((error) => {
          console.error(error)
          this.isWorking = false;
          this.$emit('swiperUpdate');
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-profile {
    align-items: center;
    text-align: center;

    .content-stack {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1rem;
      height: 100%;
      z-index: 10;
      max-width: 500px;
      margin: 0 auto 0 auto;

      svg {
        margin-bottom: 1rem;

        path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }
      }

      h3 {
        font-family: 'Brawler';
        font-weight: normal;
        font-size: 38px;
        line-height: 110%;
        text-wrap: balance;

        .callout {
          color: $yellow-tone-4;

          .darkmode & {
            color: $yellow-tone-3;
          }
        }

        .desktop & {
          font-size: 50px;
        }
      }

      p {
        font-size: 20px;
        line-height: 150%;
        text-wrap: balance;

        .desktop & {
          max-width: 400px;
        }
      }
    }

    form {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 400px;
      margin: 2rem auto 0 auto;
      z-index: 10;

      input, button {
        width: 100%;
      }

      input {
        padding: 1.2rem 1.2rem 1rem 1.2rem;
        border-radius: 10px;
        background: rgba($neutral-100, 0.05);
        text-align: center;
        border: none;

        .darkmode & {
          background: rgba($neutral-600, 0.05);
        }
      }

      button {
        margin-top: 0.5rem;
        height: 55px;
        border-radius: 10px;
        font-size: 1rem;
        padding-top: 0.8rem;

        &:disabled {
          background: rgba($neutral-100, 0.05);
          color: rgba($neutral-400, 0.5);

          .darkmode & {
            background: rgba($neutral-600, 0.05);
          }
        }
      }

      .message {
        padding: 1rem;
        border-radius: 10px;
        font-size: 0.9rem;
        text-wrap: balance;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 1.5rem auto;

        &.success {
          background: rgba($green-tone-3, 0.05);
          color: $green-tone-3;
        }

        &.warn {
          background: rgba($orange-tone-3, 0.05);
          color: $orange-tone-3;
        }
      }
    }
  }
</style>